//======================================================================================================
//
// This store controls and keeps site information and controls the application's global site information and
// will trigger events on site change
//
//======================================================================================================

import { useConfigStore as configStore } from "@/stores/configStore";
import { defineStore } from "pinia";
import { useApiStore as api } from "./apiStore";
import { useSaveStateStore as saveState } from "./ssaStore/saveState";

import { config } from "@/types/config";

export const useSiteStore = defineStore("siteStore", {
	state: () => ({
		initialized: false as boolean,
		config: null as config | null,
		activeSite: null,
		sites: [] as any
	}),
	actions: {
		async init() {
			if (this.initialized) {
				return;
			}
			await configStore().init();
			this.config = configStore().config;
			this.initialized = true;

			try {
				await this.GET_SITES();
				const localActiveSite = localStorage.getItem("mineportal-active-site");
				if (localActiveSite != null) {
					const { data: site } = await api().get(
						this.config?.endpoints.api + `/site/read/${localActiveSite}`
					);
					this.activeSite = site;
				}
			} catch (e: any) {
				console.log(e);
			}
		},
		async SET_INITIALIZED(status: boolean) {
			this.initialized = status;
		},
		async GET_SITES() {
			const { data: sites } = await api().get(this.config?.endpoints.api + `/site/read`);
			this.sites = sites;
		},
		async SET_TO_DEFAULT_SITE() {
			const localActiveSite = localStorage.getItem("mineportal-active-site");
			if (localActiveSite != null) {
				try {
					const { data: site } = await api().get(
						this.config?.endpoints.api + `/site/read/${localActiveSite}`
					);
					this.activeSite = site;
				} catch {
					this.activeSite = this.sites[0];
				}
			} else {
				this.activeSite = this.sites[0];
			}
		},
		async SET_ACTIVE_SITE(siteId: string) {
			if (siteId) {
				try {
					const { data: site } = await api().get(
						this.config?.endpoints.api + `/site/read/${siteId}`
					);
					this.activeSite = site;
					saveState().SSA_SET_ACTIVE_SAVE_STATE(null);
					localStorage.setItem("mineportal-active-site", siteId);
				} catch (e) {
					console.log(e);
				}

				//hierarchyStore().fetchHierarchy();
			}
		}
	}
});
